<template>
    <div>
        <modal :show="show">
            <div class="modal-header">
                <h5 class="modal-title">Transaction History</h5>
                <a href="javascript:void(0)" v-on:click="close()" class="close">
                    <em class="icon ni ni-cross"></em>
                </a>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <table class="table table-tranx">
                            <thead>
                                <tr class="tb-tnx-head">
                                    <th class="tb-tnx-info">
                                        Date
                                    </th>
                                    <th class="tb-tnx-info">
                                        Amount
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in transactions" v-bind:key="item.id" class="tb-tnx-item">
                                    <td class="tb-tnx-info">
                                        {{item.date}}
                                    </td>
                                    <td class="tb-tnx-info">
                                        {{AmountFormat(item.debit-item.credit)}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer bg-light">
                <button type="button" class="btn btn-danger btn-round" v-on:click="close()">Cancel</button>
            </div>
        </modal>

    </div>
</template>
<script>

    export default {
        props: ['transactions', 'show'],
        data: function () {
            return {
                loading: false,
                
            }
        },
        methods: {
            close: function () {
                this.$emit('close');
            },

            AmountFormat: function (amount) {
                return '$' + parseFloat(amount).toFixed(4).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
            },
        },

        mounted: function () {
        },

    }
</script>